/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc
 */
import * as References from './GlobalStylesRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#get
 */
export const GET_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_get';
export const GET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#getForActiveTheme
 */
export const GET_FOR_ACTIVE_THEME_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_getForActiveTheme';
export const GET_FOR_ACTIVE_THEME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FOR_ACTIVE_THEME_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getForActiveThemeRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#create
 */
export const CREATE_MUTATION_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_create';
export const CREATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['activePresetId', 'themeId', 'overrides', 'breakpointOverrides', 'fieldConfigs', 'variantOverrides', 'variantFieldConfigs'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.createRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#update
 */
export const UPDATE_MUTATION_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_update';
export const UPDATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_MUTATION_FIELD_NAME,
  args: ['id', 'activePresetId', 'themeId', 'overrides', 'breakpointOverrides', 'fieldConfigs', 'variantOverrides', 'variantFieldConfigs'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.updateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#archive
 */
export const ARCHIVE_MUTATION_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_archive';
export const ARCHIVE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ARCHIVE_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.archiveRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#unarchive
 */
export const UNARCHIVE_MUTATION_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_unarchive';
export const UNARCHIVE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNARCHIVE_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.unarchiveRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#hasBufferedChanges
 */
export const HAS_BUFFERED_CHANGES_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_hasBufferedChanges';
export const HAS_BUFFERED_CHANGES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: HAS_BUFFERED_CHANGES_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.hasBufferedChangesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#hasBufferedChangesForActiveTheme
 */
export const HAS_BUFFERED_CHANGES_FOR_ACTIVE_THEME_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_hasBufferedChangesForActiveTheme';
export const HAS_BUFFERED_CHANGES_FOR_ACTIVE_THEME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: HAS_BUFFERED_CHANGES_FOR_ACTIVE_THEME_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.hasBufferedChangesForActiveThemeRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#getBuffer
 */
export const GET_BUFFER_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_getBuffer';
export const GET_BUFFER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BUFFER_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getBufferRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#getPortalBuffer
 */
export const GET_PORTAL_BUFFER_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_getPortalBuffer';
export const GET_PORTAL_BUFFER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_BUFFER_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.getPortalBufferRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#getPortalBufferForActiveTheme
 */
export const GET_PORTAL_BUFFER_FOR_ACTIVE_THEME_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_getPortalBufferForActiveTheme';
export const GET_PORTAL_BUFFER_FOR_ACTIVE_THEME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_BUFFER_FOR_ACTIVE_THEME_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getPortalBufferForActiveThemeRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#upsertBuffer
 */
export const UPSERT_BUFFER_MUTATION_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_upsertBuffer';
export const UPSERT_BUFFER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_BUFFER_MUTATION_FIELD_NAME,
  args: ['globalStylesId', 'updatedAtPrecondition', 'activePresetId', 'themeId', 'overrides', 'breakpointOverrides', 'fieldConfigs', 'variantOverrides', 'variantFieldConfigs'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.upsertBufferRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#pushBufferLive
 */
export const PUSH_BUFFER_LIVE_MUTATION_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_pushBufferLive';
export const PUSH_BUFFER_LIVE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PUSH_BUFFER_LIVE_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.pushBufferLiveRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#pushBufferLiveForActiveTheme
 */
export const PUSH_BUFFER_LIVE_FOR_ACTIVE_THEME_MUTATION_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_pushBufferLiveForActiveTheme';
export const PUSH_BUFFER_LIVE_FOR_ACTIVE_THEME_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PUSH_BUFFER_LIVE_FOR_ACTIVE_THEME_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.pushBufferLiveForActiveThemeRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#getMergedGlobalStyles
 */
export const GET_MERGED_GLOBAL_STYLES_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_getMergedGlobalStyles';
export const GET_MERGED_GLOBAL_STYLES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MERGED_GLOBAL_STYLES_QUERY_FIELD_NAME,
  args: ['useBuffer'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getMergedGlobalStylesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#getByTheme
 */
export const GET_BY_THEME_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_getByTheme';
export const GET_BY_THEME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_THEME_QUERY_FIELD_NAME,
  args: ['themeId'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.getByThemeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#getBufferByTheme
 */
export const GET_BUFFER_BY_THEME_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_getBufferByTheme';
export const GET_BUFFER_BY_THEME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BUFFER_BY_THEME_QUERY_FIELD_NAME,
  args: ['themeId'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.getBufferByThemeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#listByPortal
 */
export const LIST_BY_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_listByPortal';
export const LIST_BY_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_BY_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.listByPortalRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc#createForTheme
 */
export const CREATE_FOR_THEME_MUTATION_FIELD_NAME = 'com_hubspot_global_styles_rpc_GlobalStylesRpc_createForTheme';
export const CREATE_FOR_THEME_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_FOR_THEME_MUTATION_FIELD_NAME,
  args: ['activePresetId', 'themeId', 'overrides', 'breakpointOverrides', 'fieldConfigs', 'variantOverrides', 'variantFieldConfigs'],
  fetcher(request, ctx) {
    var _ctx$customClient19;
    return ((_ctx$customClient19 = ctx.customClient) !== null && _ctx$customClient19 !== void 0 ? _ctx$customClient19 : chirpClient).call(References.createForThemeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});